import {
  LAUNCHLAB_ESTIMATED_CREATE_FEE_SOL,
} from "@/config/idxLaunchlabAppConfig";
import { effectiveInitialBuySol } from "@/lib/idx-launchlab/preview-initial-buy-price";
import { isInsufficientFundsWalletError } from "@/utils/walletTransactionHelpers";

/** Extra lamports headroom for network fees on top of estimated create cost. */
const LAUNCHLAB_TX_FEE_BUFFER_SOL = 0.002;

/** @param {string | number | undefined | null} raw */
export function parseInitialBuySol(raw) {
  const n = Number.parseFloat(String(raw ?? "").trim() || "0");
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** @param {string | number | undefined | null} initialBuySolRaw */
export function getLaunchRequiredSol(initialBuySolRaw) {
  const buy = effectiveInitialBuySol(parseInitialBuySol(initialBuySolRaw));
  if (buy <= 0) return 0;
  return buy + LAUNCHLAB_ESTIMATED_CREATE_FEE_SOL + LAUNCHLAB_TX_FEE_BUFFER_SOL;
}

/**
 * Pre-launch balance check — only when a first buy is set (create-only relies on wallet/simulation).
 * @param {number | null | undefined} balanceSol
 * @param {string | number | undefined | null} initialBuySolRaw
 * @returns {string | null}
 */
export function getLaunchBalanceError(balanceSol, initialBuySolRaw) {
  const buy = effectiveInitialBuySol(parseInitialBuySol(initialBuySolRaw));
  if (buy <= 0) return null;

  const required = getLaunchRequiredSol(initialBuySolRaw);
  const balance = Number.isFinite(balanceSol) ? balanceSol : 0;
  if (balance >= required) return null;

  return `Insufficient SOL. You need at least ${buy} SOL for your first buy plus network fees. You have ${balance.toFixed(4)} SOL.`;
}

/** @param {unknown} err */
export function isInsufficientSolLaunchError(err) {
  return isInsufficientFundsWalletError(err);
}

/**
 * @param {unknown} err
 * @param {string | number | undefined | null} [initialBuySolRaw]
 */
export function formatInsufficientSolLaunchError(err, initialBuySolRaw) {
  void err;
  const buy = effectiveInitialBuySol(parseInitialBuySol(initialBuySolRaw));
  if (buy > 0) {
    return "Insufficient SOL. Please top up your wallet and try again.";
  }
  return "Insufficient SOL in your wallet. Add SOL for network fees and try Launch coin again.";
}
